import dayjs from 'dayjs';

let initialized = false;

export const initCalendar = onLoadFunction => {
  if (!initialized) {
    const googleApiScript = document.createElement('script');
    googleApiScript.src = 'https://apis.google.com/js/api.js';
    if (onLoadFunction && typeof onLoadFunction === 'function') {
      googleApiScript.onload = onLoadFunction;
    }
    document.body.appendChild(googleApiScript);

    initialized = true;
  }
};

const createUUID = () => {
  let dt = new Date().getTime();
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
};

export const generateGoogleEvent = classroomName => {
  return {
    summary: classroomName,
    start: {
      dateTime: dayjs().format('YYYY-MM-DDTHH:mm:ss'),
      timeZone: 'Europe/Madrid'
    },
    end: {
      dateTime: dayjs()
        .add(2, 'hours')
        .format('YYYY-MM-DDTHH:mm:ss'),
      timeZone: 'Europe/Madrid'
    },
    conferenceData: {
      createRequest: {
        requestId: createUUID()
      }
    }
  };
};
